export const TIME_DELAY = {
  SHORT: 2000,
  MEDIUM: 4000,
  LONG: 8000
};
